// Nach Anpassung der package.json: npm update --save
// https://stackoverflow.com/questions/12478679/npm-install-vs-update-whats-the-difference

import { createApp } from 'vue';
import App from './App.vue'
import router from './router'

createApp(App).use(router).mount('#app')
